export const VERIFIED = {
    TITLE: 'Email Verified',
    DESCRIPTION: 'Your email has been verified. Please login to your account and fill up the forms.'
};

export const VERIFY = {
    TITLE: 'Verify Your Email Address',
    DESCRIPTION: 'Check your email and click the button to activate your account'
};